import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import styles from "./IndretDetall.module.css";
import { getIdIndretLlista, getDadesOriginalsIndret } from "../../reducers";
import IndretFormulari from "./IndretFormulari";
import * as rutes from "../../routes";
import { MISSATGE_SPIN_INDRET } from "../../constantsFormularis";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import { obtenirDadesIndret } from "../../actions";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { rutaIndrets, rutaEdicioIndret } from "../../routes";

class IndretDetall extends Component {
  componentDidMount() {
    const { idIndret } = this.props;
    this.props.obtenirDadesIndret(idIndret);
  }

  generarBotoDonarDeBaixa() {
    return (
      <Link
        to={{
          pathname: rutes.rutaBaixaIndret,
          query: { render: false }
        }}
      >
        <Button size="large">Donar de baixa</Button>
      </Link>
    );
  }

  generarBotoEditar() {
    return (
      <Link
        to={{
          pathname: rutaEdicioIndret,
          query: { render: false }
        }}
      >
        <Button type="primary" size="large">
          Editar
        </Button>
      </Link>
    );
  }

  generarBotoTornar() {
    return (
      <Link
        className={styles.back}
        to={{
          pathname: rutaIndrets,
          query: { render: false }
        }}
      >
        <Button icon="left">Tornar</Button>
      </Link>
    );
  }

  render() {
    const { dadesOriginals } = this.props;

    if (!dadesOriginals || !dadesOriginals.id) {
      return (
        <Spin
          spinning={true}
          delay={RETARD_MILISEGONS_APARICIO_SPINNER}
          tip={MISSATGE_SPIN_INDRET}
        />
      );
    }

    const estat = dadesOriginals && dadesOriginals.dataBaixa ? false : true;
    const botoBaixaIndret = estat ? this.generarBotoDonarDeBaixa() : null;
    const botoEditar = this.generarBotoEditar();
    const botoTornar = this.generarBotoTornar();

    return (
      <div className={styles.indretIntroduccioDetall}>
        <div className={styles.indretIntroduccioDetallContenidor}>
          <IndretFormulari esEditable={false} />
        </div>
        <div className={styles.indretIntroduccioDetallBotons}>
          {botoEditar}
          {botoBaixaIndret}
        </div>
        <div className={styles.indretBotoTornar}>{botoTornar}</div>
      </div>
    );
  }
}

IndretDetall.propTypes = {
  idIndret: PropTypes.number,
  obtenirDadesIndret: PropTypes.func.isRequired,
  dadesOriginals: PropTypes.object
};

const mapStateToProps = state => {
  return {
    idIndret: getIdIndretLlista(state),
    dadesOriginals: getDadesOriginalsIndret(state)
  };
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, { obtenirDadesIndret })(IndretDetall)
);
